import { create } from 'zustand';

import type { ErrorDebugLog, ErrorDebugLogPayload, ErrorDebugLogType } from './errorDebugLogStore.types';

interface ErrorDebugLogState {
  readonly isLoggingEnabled: boolean;
  readonly debugLogs: ErrorDebugLog[];
}

const useErrorDebugLogStore = create<ErrorDebugLogState>(() => ({
  isLoggingEnabled: false,
  debugLogs: [],
}));

type SetErrorLoggingEnabled = (isEnabled: boolean) => void;
export const setErrorLoggingEnabled: SetErrorLoggingEnabled = (isEnabled) => {
  useErrorDebugLogStore.setState({ isLoggingEnabled: isEnabled });
};

type AddErrorDebugLog = (
  debugLogs: ErrorDebugLog[],
  payload: ErrorDebugLogPayload,
  type: ErrorDebugLogType
) => ErrorDebugLog[];
const addErrorDebugLog: AddErrorDebugLog = (debugLogs, payload, type) => [
  ...debugLogs,
  {
    id: `${payload.name}_${new Date().getTime()}`,
    type,
    payload,
  },
];

type LogComponentError = (componentName: string, error: unknown) => void;
export const logComponentError: LogComponentError = (componentName, error) => {
  const message = error instanceof Error ? error.message : undefined;

  if (!useErrorDebugLogStore.getState().isLoggingEnabled) {
    return;
  }

  useErrorDebugLogStore.setState((state) => ({
    debugLogs: addErrorDebugLog(state.debugLogs, { name: componentName, message }, 'Component'),
  }));
};

type LogApiError = (payload: ErrorDebugLogPayload) => void;
export const logApiError: LogApiError = (payload) => {
  if (!useErrorDebugLogStore.getState().isLoggingEnabled) {
    return;
  }

  useErrorDebugLogStore.setState((state) => ({
    debugLogs: addErrorDebugLog(state.debugLogs, payload, 'Api'),
  }));
};

type ClearErrorLogs = () => void;
export const clearErrorLogs: ClearErrorLogs = () => {
  useErrorDebugLogStore.setState({ debugLogs: [] });
};

type UseGetErrorDebugLogs = () => ErrorDebugLog[];
export const useGetErrorDebugLogs: UseGetErrorDebugLogs = () => useErrorDebugLogStore((state) => state.debugLogs);

type UseGetErrorDebugLogsCount = () => number;
export const useGetErrorDebugLogsCount: UseGetErrorDebugLogsCount = () =>
  useErrorDebugLogStore((state) => state.debugLogs.length);
